var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640.09 165.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#30302f;}.cls-4,.cls-5{fill:#f1f3f4;}.cls-5{stroke:#f1f3f4;stroke-miterlimit:10;stroke-width:4px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -128.71,
    y: -128.47,
    width: 547,
    height: 386.77
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "White_Boxed_Long") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.98,
    y: 27.68,
    width: 146.21,
    height: 109.79,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.78,140.44h-61A15.66,15.66,0,0,1,33,124.63c0-5.1,0-10.19,0-15.28V42.15a15.54,15.54,0,0,1,6.34-13.08,15.21,15.21,0,0,1,9-3.08c.42,0,81.6,0,121.78,0a16.48,16.48,0,0,1,7.28,1.39c5.81,2.8,8.85,7.48,9.24,13.9,0,.37,0,.73,0,1.1q0,40.85,0,81.7a15.86,15.86,0,0,1-1.33,7c-2.87,6.06-7.68,9.35-14.41,9.37-20.37.07-40.75,0-61.12,0m-29.26-68c-1.55,0-2.85-.07-4.14,0a43.11,43.11,0,0,0-6.34.65A22.25,22.25,0,0,0,52.65,93.28c-.49,7.41-.61,14.85-.64,22.28a17.23,17.23,0,0,0,8.57,15.35,2.79,2.79,0,0,0,2.34.67c5.82,0,11.64,0,17.46,0a16.76,16.76,0,0,0,5.66-.93,16.55,16.55,0,0,0,11.07-15.47c0-7.75,0-24.33,0-25h33.1c1.83-5.52,3.63-10.92,5.51-16.58-.86,0-21.41,0-31.07,0A4.37,4.37,0,0,0,101,75.08c-1.1,1.27-2.37,2.4-3.64,3.68-.36-1.78-.32-23.22,0-24.47H133c1.83-5.5,3.72-11,5.48-16.55a9.93,9.93,0,0,0-1.16,0c-9.4,0-18.81,0-28.21,0a3.14,3.14,0,0,0-2,.74Q94.32,48,81.53,57.59a2.27,2.27,0,0,0-1,2.07C80.54,63.3,80.52,72.45,80.52,72.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.14,120.28c-1.66-.06-3.33,0-5-.12C67.32,120,66,118,65.89,115.37c.08-2.23.14-15.68.23-20a9.3,9.3,0,0,1,6-8.66,4.42,4.42,0,0,1,1.5-.38c2.27-.05,4.55,0,7,0,0,1.41-.07,19.27-.06,27"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M271.92,58.45c0,17-12.64,30.1-29.24,30.1H218.6V28.35h24.08C259.28,28.35,271.92,41.42,271.92,58.45Zm-13.24,0c0-10.32-6.54-16.86-16-16.86H232.36V75.31h10.32C252.14,75.31,258.68,68.77,258.68,58.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M301.08,78.23A11.23,11.23,0,0,0,309.33,75l10.32,5.94c-4.21,5.84-10.58,8.85-18.75,8.85-14.7,0-23.82-9.89-23.82-22.7s9.29-22.7,22.88-22.7c12.55,0,21.84,9.71,21.84,22.7a25.23,25.23,0,0,1-.51,5.16H290.75C292.39,76.68,296.34,78.23,301.08,78.23ZM309,62.58c-1.38-5-5.25-6.8-9.12-6.8-4.9,0-8.17,2.41-9.37,6.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M350.52,78.23A11.24,11.24,0,0,0,358.78,75L369.1,80.9c-4.21,5.84-10.58,8.85-18.75,8.85-14.7,0-23.82-9.89-23.82-22.7s9.29-22.7,22.88-22.7c12.55,0,21.84,9.71,21.84,22.7a24.53,24.53,0,0,1-.52,5.16H340.21C341.84,76.68,345.8,78.23,350.52,78.23Zm7.92-15.65c-1.38-5-5.25-6.8-9.12-6.8-4.9,0-8.17,2.41-9.37,6.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M424.83,67.05c0,12.81-9.29,22.7-20.56,22.7-5.76,0-10-2-12.81-5.24v21.24h-12.9V45.55h12.9v4c2.84-3.27,7.05-5.24,12.81-5.24C415.54,44.35,424.83,54.24,424.83,67.05Zm-12.9,0c0-6.45-4.3-10.49-10.24-10.49s-10.23,4-10.23,10.49,4.3,10.49,10.23,10.49S411.93,73.5,411.93,67.05Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M446.33,41.59V53.2h22.36V66.45H446.33v22.1H432.57V28.35h36.55V41.59Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M476.86,25.77h12.9V88.55h-12.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M497.07,67.05a22.79,22.79,0,1,1,22.78,22.7A22.53,22.53,0,0,1,497.07,67.05Zm32.68,0c0-6.11-4.3-10.15-9.9-10.15s-9.88,4-9.88,10.15,4.3,10.15,9.88,10.15S529.75,73.16,529.75,67.05Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M609.29,45.55l-13.76,43h-12l-6.88-23-6.88,23h-12l-13.76-43h13.76l6.2,23,6.71-23h12l6.71,23,6.19-23Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.43,117.07h-7.92v24h-7v-24h-7.92V110.3h22.88Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272.83,134.32v6.78H253.47V110.3h19.14v6.77h-12.1v5.11h11v6.69h-11v5.45Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M279.21,125.7a15.61,15.61,0,0,1,16-16,15.36,15.36,0,0,1,13.2,7.13l-6.07,3.52a8,8,0,0,0-7.13-3.79c-5.46,0-9,3.66-9,9.16s3.52,9.15,9,9.15a7.93,7.93,0,0,0,7.13-3.78l6.07,3.52a15.27,15.27,0,0,1-13.2,7.13A15.62,15.62,0,0,1,279.21,125.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.45,110.3v30.8h-7V128.87h-9.68V141.1h-7V110.3h7v11.79h9.68V110.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.89,110.3v30.8h-5.28l-11.88-16.72V141.1h-7.05V110.3H354L365.85,127V110.3Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M380.8,125.7a16,16,0,1,1,16,16A15.88,15.88,0,0,1,380.8,125.7Zm25,0a9,9,0,1,0-9,9.15A8.77,8.77,0,0,0,405.8,125.7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M438.8,134.32v6.78h-18V110.3h7v24Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M442.76,125.7a16,16,0,1,1,16,16A15.88,15.88,0,0,1,442.76,125.7Zm25,0a9,9,0,1,0-9,9.15A8.77,8.77,0,0,0,467.75,125.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M513.2,126.58c0,9.42-6.55,15.14-15.18,15.14-9.68,0-16.63-7.13-16.63-16a16,16,0,0,1,16.15-16.06,15.74,15.74,0,0,1,13.46,7l-6,3.43a9.25,9.25,0,0,0-16.59,5.64c0,5.23,3.7,9.06,9.68,9.06,4.09,0,6.78-1.8,7.88-4.75h-8.23v-6.16H513.2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M528.16,110.3v30.8h-7V110.3Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M556.76,134.32v6.78H537.4V110.3h19.14v6.77h-12.1v5.11h11v6.69h-11v5.45Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M563.14,134.1l6.07-3.52a6.44,6.44,0,0,0,6.47,4.27c3.35,0,4.18-1.32,4.18-2.51,0-1.89-1.76-2.64-6.38-3.91s-9.06-3.48-9.06-9.38,5-9.37,10.34-9.37A11.94,11.94,0,0,1,586,116.63l-5.94,3.48c-1.05-2.2-2.51-3.57-5.32-3.57-2.2,0-3.3,1.11-3.3,2.34,0,1.41.74,2.37,5.54,3.83s9.9,3,9.9,9.54c0,5.95-4.75,9.47-11.44,9.47C569,141.72,564.86,138.64,563.14,134.1Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 223.72,
    y1: 97.99,
    x2: 373,
    y2: 97.99
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 396.66,
    y1: 98,
    x2: 588.32,
    y2: 98
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.6a0fddfa9c2d3933f64ad5a87ec32491.svg";
export { ForwardRef as ReactComponent };